// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1fg9r","savePackageButton":"ClientWallet_savePackageButton__1YZz1"};